const WhatsNew = () => import('@/views/Dashboard/WhatsNew/WhatsNew');

// Not permission-gated, for the same reason the guide is not: release notes describe the product,
// not a screen the user may or may not reach. The optional :id opens a specific release so a link
// to one can be shared; without it the newest is shown.
export default [
  {
    path: '/whats-new',
    name: 'whats-new',
    component: WhatsNew,
  },
  {
    path: '/whats-new/:id',
    name: 'whats-new-release',
    component: WhatsNew,
  },
];
